<template>
  <div>
    <article class="forum-widget">
      <div class="forum-widget__user">
        <img
          class="forum-widget__user-avatar"
          src="/img/forums/avatar-1.jpg"
          alt=""
        />
        <div class="forum-widget__user-name">Baty Alquawen</div>
        <div class="forum-widget__user-role">Community Manager</div>
      </div>
      <div class="forum-widget__msg">
        <h4 class="forum-widget__msg-heading">2016 In Review</h4>
        <p class="forum-widget__msg-text">
          Greetings Survivors, As we wrap up 2016, we'd like to take a moment
          and lookback on what has been done so far, and what is to come. 2016
          has been a pivotal year ...
        </p>
      </div>
      <div class="forum-widget__details">
        <div class="forum-widget__details-text">
          Posted: <br /><span class="text-bold">December 23, 2016</span>
        </div>
        <div class="forum-widget__details-text text-bold text-red">
          47 posts
        </div>
      </div>
      <div class="forum-widget__link">
        <a href="#" class="forum-widget__link-icon">
          <i class="iconmoon-link"></i>
        </a>
      </div>
    </article>

    <article class="forum-widget">
      <div class="forum-widget__user">
        <img
          class="forum-widget__user-avatar"
          src="/img/forums/avatar-empty.png"
          alt=""
        />
        <div class="forum-widget__user-name">Username 123</div>
        <div class="forum-widget__user-role">Community Manager</div>
      </div>
      <div class="forum-widget__msg">
        <h4 class="forum-widget__msg-heading">
          Internal Milestone - Road to Beta
        </h4>
        <p class="forum-widget__msg-text">
          This week, we've reached an important internal milestone of completely
          deprecating our old SQF scripting language (it's been with us, in some
          form, ever since the first...
        </p>
      </div>
      <div class="forum-widget__details">
        <div class="forum-widget__details-text">
          Posted: <br /><span class="text-bold">December 23, 2016</span>
        </div>
        <div class="forum-widget__details-text text-bold text-red">
          90 posts
        </div>
      </div>
      <div class="forum-widget__link">
        <a href="#" class="forum-widget__link-icon">
          <i class="iconmoon-link"></i>
        </a>
      </div>
    </article>

    <article class="forum-widget">
      <div class="forum-widget__user">
        <img
          class="forum-widget__user-avatar"
          src="/img/forums/avatar-empty.png"
          alt=""
        />
        <div class="forum-widget__user-name">Username 123</div>
        <div class="forum-widget__user-role">Community Manager</div>
      </div>
      <div class="forum-widget__msg">
        <h4 class="forum-widget__msg-heading">Lorem Ipsum Dolor Sit Amet</h4>
        <p class="forum-widget__msg-text">
          Greetings Survivors, As we wrap up 2016, we'd like to take a moment
          and look back on what has been done so far, and what is to come. 2016
          has been a pivotal year ...
        </p>
      </div>
      <div class="forum-widget__details">
        <div class="forum-widget__details-text">
          Posted: <br /><span class="text-bold">December 23, 2016</span>
        </div>
        <div class="forum-widget__details-text text-bold text-red">
          100 posts
        </div>
      </div>
      <div class="forum-widget__link">
        <a href="#" class="forum-widget__link-icon">
          <i class="iconmoon-link"></i>
        </a>
      </div>
    </article>

    <Pagination class="dev-hub-forum__pager" />
  </div>
</template>

<script>
import Pagination from "../common/Pagination.vue";
export default {
  components: {
    Pagination
  }
};
</script>
